import { t as tr } from './i18n';
/**
 * Numele și poziționarea produsului, într-un singur loc.
 * Schimbi `name` și `tagline` aici și se schimbă în bara laterală,
 * în titlul paginii și în log-ul serverului.
 */
export const BRAND = {
  name: 'Procumi',
  /** în limba de acum */
  get tagline(): string {
    return tr('Cereri de ofertă, comparate rapid');
  },
  /** unde scriu firmele când au nevoie de ajutor (temporar adresa de vânzări) */
  helpEmail: 'sales@procumi.com',
  /** site-ul de prezentare: spre el duc „prin Procumi” din mailuri și pagina furnizorului */
  site: 'https://procumi.com',
};

/**
 * Rândul de la finalul mailurilor către furnizori: fiecare cerere trimisă din
 * Procumi ajunge la mai mulți furnizori, iar unii dintre ei cumpără și ei.
 */
export const sentWith = (): string =>
  `${BRAND.name} – ${BRAND.tagline.toLowerCase()}: ${BRAND.site.replace(/^https:\/\//, '')}`;

/** Titlul paginii din browser. */
export const pageTitle = (): string => `${BRAND.name} – ${BRAND.tagline.toLowerCase()}`;
